import OrgManagement from './OrgManagement'
import Overview from './Overview'
import PersonDetails from './People/PersonDetails'
import People from './People/People'
import Reports from './Reports/Reports'
import Imports from './Imports/Imports'
import Integrations from './Integrations/Integrations'
import IntegrationDetails from './Integrations/IntegrationDetails'
import ConnectionDetails from './Integrations/ConnectionDetails'
import Permissions from './Permissions/Permissions'
import Categories from './Categories/Categories'
import CategoryDetails from './Categories/CategoryDetails'
import Groups from './Groups/Groups'
import GroupDetails from './Groups/GroupDetails'
import Settings from './Settings/Settings'

export { OrgManagement as default }

export const overviewRoute = {
	path: 'overview',
	name: 'overview',
	component: Overview,
}

export const userDetailsRoute = {
	path: 'users/:id',
	name: 'user',
	component: PersonDetails,
	props: (route) => ({ userId: route.params.id }),
	meta: { titleKey: 'settings_orgprofile_people' },
}

export const usersRoute = {
	path: 'users',
	name: 'users',
	component: People,
	props: (route) => ({ searchTerm: route.query.q }),
	meta: { titleKey: 'settings_orgprofile_people' },
}

export const reportsRoute = {
	path: 'reports',
	name: 'reports',
	component: Reports,
	meta: { titleKey: 'admin_overview_reports_title' },
}

export const importsRoute = {
	path: 'imports',
	name: 'imports',
	component: Imports,
	meta: { titleKey: 'admin_sidebar_imports_label' },
}

export const importDetailsRoute = {
	path: 'imports/:id',
	name: 'import',
	component: Imports,
	meta: { titleKey: 'admin_sidebar_imports_label' },
}

export const integrationsRoute = {
	path: 'integrations',
	name: 'integrations',
	component: Integrations,
	meta: {
		titleKey: 'admin_overview_integrations_title',
		requiresPermission: 'isSupportUser',
	},
}

export const integrationDetailsRoute = {
	path: 'integrations/available/:id',
	name: 'integration',
	component: IntegrationDetails,
	props: (route) => ({
		integrationId: route.params.id,
		integrationObject: route.query.integrationObject
			? JSON.parse(route.query.integrationObject)
			: null,
	}),
	meta: {
		titleKey: 'admin_overview_integrations_title',
		requiresPermission: 'isSupportUser',
	},
}

export const connectionDetailsRoute = {
	path: 'integrations/connections/:id',
	name: 'connection',
	component: ConnectionDetails,
	props: (route) => ({ connectionId: route.params.id }),
	meta: {
		titleKey: 'admin_overview_integrations_title',
		requiresPermission: 'isSupportUser',
	},
}

export const settingsRoute = {
	path: 'settings',
	name: 'settings',
	component: Settings,
	meta: { titleKey: 'common_settingsapp' },
}

export const permissionsRoute = {
	path: 'permissions',
	name: 'permissions',
	component: Permissions,
	meta: { titleKey: 'admin_sidebar_permissions_label' },
}

export const categoriesRoute = {
	path: 'categories',
	name: 'categories',
	component: Categories,
	meta: { titleKey: 'admin_categories_title' },
}

export const categoryDetailsRoute = {
	path: 'categories/:id',
	name: 'category',
	component: CategoryDetails,
	props: (route) => ({
		categoryId: route.params.id,
		openNewGroupModal: !!route.query.newGroup,
	}),
	meta: { titleKey: 'admin_categories_title' },
}

export const groupsRoute = {
	path: 'groups',
	name: 'groups',
	component: Groups,
	props: (route) => ({
		searchTerm: route.query.q,
		showNewModal: !!route.query.new,
	}),
	meta: { titleKey: 'admin_categories_groups_label' },
}

export const groupDetailsRoute = {
	path: 'groups/:id',
	name: 'group',
	component: GroupDetails,
	props: (route) => ({
		groupId: route.params.id,
		cachedGroup: route.params.group,
	}),
	meta: { titleKey: 'admin_categories_groups_label' },
}

export const mainRoute = {
	path: '/organization',
	name: 'org',
	component: OrgManagement,
	meta: { titleKey: 'settings_option_organization' },
	children: [
		overviewRoute,
		usersRoute,
		userDetailsRoute,
		groupsRoute,
		groupDetailsRoute,
		categoriesRoute,
		categoryDetailsRoute,
		reportsRoute,
		importsRoute,
		importDetailsRoute,
		integrationsRoute,
		integrationDetailsRoute,
		connectionDetailsRoute,
		permissionsRoute,
		settingsRoute,
	],
}

export const routes = [mainRoute]
